Ext.define('SA.view.businesslist.List', {
    alias: 'widget.businesses-list-window-list',
    extend: 'Ext.Component',

    autoEl: {tabIndex: -1},

    tpl: [
        '<table class="sa-map-business-list-table">',
            '<colgroup><col style="width:{numberWidth}px" /></colgroup>',
            '<tpl for="rows">',
                '<tr data-index="{number}" class="sa-map-business-list-row">',
                    '<td class="sa-map-business-list-td sa-map-business-list-number-td">{number}</td>',
                    '<td class="sa-map-business-list-td sa-map-business-list-name-td">{name:htmlEncode}</td>',
                '</tr>',
            '</tpl>',
        '</table>'
    ],

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: 'tr',
            scope: this,

            click(ev, target) {
                var index = +target.getAttribute('data-index');

                this.setSelected(this.selected === index ? null : index);
            },

            mouseout(ev, target) {
                Ext.fly(target).removeCls('sa-map-business-list-row-hover');
            },

            mouseover(ev, target) {
                Ext.fly(target).addCls('sa-map-business-list-row-hover');
            }
        });

        this.refresh();
    },

    getNumberColumnWidth() {
        var firstCell = this.el.query('.sa-map-business-list-number-td')[0];

        return Ext.fly(firstCell).getWidth();
    },

    getSelected() {
        return this.selected;
    },

    refresh() {
        var selected = this.selected,
            el = this.el;

        if (el) {
            el.query('.sa-map-business-list-row').forEach(el => {
                Ext.fly(el).ifCls(+el.getAttribute('data-index') === selected, 'sa-map-business-list-row-selected');
            });
        }
    },

    setSelected(index) {
        index = index == null ? index : +index;

        if (this.selected !== index) {
            this.selected = index;

            this.refresh();

            this.fireEvent('change:selected', this);
        }
    },

    update() {
        this.callParent(arguments);

        this.refresh();
    }
});